module.exports = {"patient":{"menu-banners":{"queue-instant-video":"Your request for an Immediate Video Consultation is waiting to be attended to. ","queue-written":"Your request for a Written Consultation is waiting to be attended to. \nYou will receive a notification when the professional has accepted your consultation.","queue-chat":"Your Chat request is waiting to be attended to. ","queue-call":"Your call request is waiting to be answered. ","new-chat-messages":"You have new chat messages. "}}}


//////////////////
// WEBPACK FOOTER
// ./src/lang/en/public/views/patient/menu-banner.json
// module id = 590
// module chunks = 116